import {FadeInView} from '@/components/basic/animations';
import React, {useCallback} from 'react';
import {getGameCategory, getGameProvider} from '../home.service';
import globalStore from '@/services/global.state';
import {Image, View} from 'react-native';
import Text from '@/components/basic/text';
import {NativeTouchableOpacity} from '@/components/basic/touchable-opacity';
import theme from '@/style';
import {NoMoreData} from '@/components/basic/default-page';
import {getGamePicUrl, GamePicType} from '@/components/utils/utils';
import HomeFloorHeader from './home-floor-header';
import {useTranslation} from 'react-i18next';
import homeStore from '../home.refresh.service';
import Picker from '@/components/basic/picker';
import {
  NewGameListItem,
  NewGameListParams,
  postNewGameList,
} from '@/common-pages/casino/casino.service';
import {normalizeGamePush} from '@utils/game';
type OptionsProps = {
  label: string;
  value: string;
};
const HomeLive = () => {
  const [gameCategory, setGameCategory] = React.useState<OptionsProps[]>([]);
  const [currentGameCategory, setCurrentGameCategory] = React.useState('');
  const [loading, setLoading] = React.useState(false);

  const [gameProvider, setGameProvider] = React.useState<OptionsProps[]>([]);
  const [currentGameProvider, setCurrentGameProvider] = React.useState('');
  const initLive = () => {
    // 获取分类
    getGameCategory('liveCasino')
      .then(res => {
        const list = res.map(v => ({label: v.name, value: v.id}));
        list.unshift({label: 'All', value: ''});
        globalStore.setItem('HomeCasinoDistinctFieldValues', list);
        setGameCategory(list);
        setCurrentGameCategory(list[0].value);
      })
      .catch(() => {
        setGameCategory([]);
      });
    // 获取厂商
    getGameProvider('liveCasino')
      .then(res => {
        const list = res.map(v => ({label: v.name, value: v.id}));
        list.unshift({label: 'All', value: ''});
        globalStore.setItem('HomeCasinoSourceValues', list);
        setGameProvider(list);
        setCurrentGameProvider(list[0].value);
      })
      .catch(() => {
        setGameProvider([]);
      });
  };
  React.useEffect(() => {
    initLive();
    const sub = homeStore.refresh.subscribe(() => {
      getCasinoList();
    });
    return () => {
      sub.unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const pageNo = React.useRef(1);
  const total = React.useRef(0);
  const noMore = React.useRef(false);
  const [gameList, setGameList] = React.useState<(NewGameListItem | null)[]>(
    Array(9).fill(null),
  );

  const getList = useCallback(
    (loadMore = false) => {
      setLoading(true);
      if (loadMore) {
        ++pageNo.current;
      } else {
        pageNo.current = 1;
      }

      const params: NewGameListParams = {
        l1CategoryId: 3,
        l2CategoryId: currentGameCategory,
        pageNo: pageNo.current,
        providerId: currentGameProvider,
        pageSize: 21,
      };
      return postNewGameList(params)
        .then(game => {
          if (!loadMore) {
            setGameList(game.content || []);
          } else {
            setGameList(_gameList => [..._gameList, ...(game.content || [])]);
          }
          total.current = game.totalSize;
          noMore.current = game.totalPages <= pageNo.current;
        })
        .finally(() => {
          setLoading(false);
          !loadMore && homeStore.refreshEnd.next();
        });
    },
    [currentGameCategory, currentGameProvider],
  );
  const getCasinoList = (loadMore = false) => {
    getList(loadMore);
  };
  React.useEffect(() => {
    getCasinoList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentGameCategory, currentGameProvider]);
  const i18n = useTranslation();
  const [pickerOpen, setPickerOpen] = React.useState(false);
  return (
    <FadeInView
      style={[
        // eslint-disable-next-line react-native/no-inline-styles
        {
          height: 'auto',
        },
        theme.padding.btml,
      ]}>
      <HomeFloorHeader
        color="rgba(201, 228, 209, 0.50)"
        title={i18n.t('home.tab.liveCasino')}
        showRightDom
        rightDom={
          gameProvider.length > 1 ? (
            <Picker
              list={gameProvider}
              value={currentGameProvider}
              onValueChange={value => {
                setCurrentGameProvider(value);
                setPickerOpen(false);
              }}
              title={i18n.t('home.label.provedores')}
              open={pickerOpen}
              setOpen={setPickerOpen}
              titleRender={
                <View
                  style={[
                    theme.flex.centerByCol,
                    theme.flex.row,
                    theme.background.white,
                    theme.borderRadius.xs,
                    theme.border.greyAccent,
                    theme.flex.between,
                    theme.padding.tbxxs,
                    theme.padding.lrs,
                    // eslint-disable-next-line react-native/no-inline-styles
                    {
                      minWidth: 80,
                    },
                  ]}>
                  {/*<Text calc>{currentGameProvider}</Text>*/}
                  <Text calc>
                    {
                      gameProvider.find(
                        item => item.value === currentGameProvider,
                      )?.label
                    }
                  </Text>
                  <Image
                    source={require('@assets/icons/down.webp')}
                    style={[theme.icon.xs]}
                  />
                </View>
              }
            />
          ) : (
            <></>
          )
        }
      />
      {gameCategory?.length > 0 && (
        <View
          style={[
            theme.flex.row,
            theme.padding.leftl,
            theme.padding.rightxs,
            theme.flex.wrap,
            theme.margin.tops,
          ]}>
          {gameCategory.map(type => {
            const active = currentGameCategory === type.value;
            return (
              <NativeTouchableOpacity
                onPress={() => {
                  setCurrentGameCategory(type.value);
                }}
                style={[
                  theme.margin.rights,
                  theme.margin.btms,
                  theme.background.white,
                  theme.borderRadius.xs,
                  theme.padding.tbxxs,
                  theme.padding.lrs,
                  active && [theme.background.main],
                ]}>
                <Text
                  calc
                  color={
                    active ? theme.basicColor.white : theme.fontColor.main
                  }>
                  {type.label}
                </Text>
              </NativeTouchableOpacity>
            );
          })}
        </View>
      )}
      {gameList?.length ? (
        <>
          <div className="px-3 grid grid-cols-3 gap-1">
            {gameList.map(game => {
              return (
                <div
                  key={game?.id}
                  className="rounded-lg overflow-hidden bg-[#E8EBEE] aspect-[113/149] bg-full"
                  style={{
                    backgroundImage: `url(${getGamePicUrl(
                      GamePicType.V_RECTANGLE,
                      game?.source || '',
                      game?.tripartiteUniqueness || '',
                    )})`,
                  }}
                  onClick={() => {
                    game && normalizeGamePush(game.id, true);
                  }}
                />
              );
            })}
          </div>
          <View
            style={[theme.margin.topxs, theme.margin.btms, theme.flex.center]}>
            <Text accent calc>
              {gameList.length} / {total.current}
            </Text>
          </View>
          {gameList.length < total.current ? (
            <View style={[theme.flex.row]}>
              <View style={[theme.flex.flex1]} />
              <NativeTouchableOpacity
                onPress={() => {
                  !loading && getCasinoList(true);
                }}
                style={[
                  theme.background.white,
                  theme.borderRadius.m,
                  theme.flex.flex2,
                  theme.flex.center,
                  theme.padding.l,
                ]}>
                <Text blod calc>
                  {i18n.t('label.loadMore')}
                </Text>
              </NativeTouchableOpacity>
              <View style={[theme.flex.flex1]} />
            </View>
          ) : (
            <NoMoreData />
          )}
        </>
      ) : (
        <NoMoreData />
      )}
    </FadeInView>
  );
};

export default HomeLive;
